var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Scenarios')))]), _c('div', {
    staticClass: "px-4"
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('Category'),
      "items": _vm.categories,
      "dense": ""
    },
    model: {
      value: _vm.category,
      callback: function callback($$v) {
        _vm.category = $$v;
      },
      expression: "category"
    }
  })], 1), _vm._l(_vm.scenarioLibraries.filter(function (item) {
    return item.category == _vm.category;
  }), function (scenarioLibrary) {
    return [_c('v-divider'), _c('ScenarioLibrary', {
      attrs: {
        "item": scenarioLibrary
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }